import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=5d976bf6&scoped=true"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"
import style0 from "./DashboardView.vue?vue&type=style&index=0&id=5d976bf6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d976bf6",
  null
  
)

export default component.exports